import { AbstractDataProviderV2, A9Service } from 'components/system';

@A9Service('businessStaffDataProvider')
export class BusinessStaffDataProvider extends AbstractDataProviderV2 {
    constructor() {
        super();
        this.setApiUrl('middle://rs/customers/business/{businessId}/staff');
    }

    public getStaffMember(businessId: string, staffMemberId: string): Promise<any> {
        const url = this.helper.buildUrl(this.url, { businessId });

        return this.service.getItem<any>(`${url}/${staffMemberId}`);
    }

    public deleteStaffMember(businessId: string, staffMemberId: string): Promise<any> {
        const url = this.helper.buildUrl(this.url, { businessId });

        return this.service.updateRequest<any>(`${url}/${staffMemberId}`, 'DELETE');
    }

    public updateStaffMember(businessId: string, staffMemberId: string, data: any): Promise<any> {
        const url = this.helper.buildUrl(this.url, { businessId });

        return this.service.updateRequest<any>(`${url}/${staffMemberId}`, 'PUT', data);
    }

    public updateMainContact(businessId: string, staffMemberId: string): Promise<any> {
        const url = this.helper.buildUrl(this.url, { businessId });

        return this.service.updateRequest<any>(`${url}/${staffMemberId}/main-contact`, 'PUT', { mainContact: true });
    }
}
